import { Link } from "react-router";

import { isInvoiceOnlyScope } from "@/lib/deployment/public-scope";

export function PublicFooter() {
  const invoiceOnly = isInvoiceOnlyScope();

  return (
    <footer className="border-t border-border bg-canvas">
      <div className="mx-auto max-w-6xl px-4 py-5 text-xs leading-5 text-tertiary">
        <p>
          {invoiceOnly
            ? "Privacy: customer, item, and local document records stay only in this browser. PDF/XML files are browser downloads you manage. We do not collect or store document contents or business/customer records."
            : "Privacy: seller, customer, item, local document, invoice design, reusable preset, and uploaded CSV/XLSX records stay only in this browser. PDF/XML/ZIP files are browser downloads you manage. We do not collect or store document contents or business/customer records."}
        </p>
        <div className="mt-2 flex flex-wrap gap-3">
          <span>Copyright 2026 POLENEST</span>
          <Link to="/legal/privacy" className="text-secondary hover:text-primary">
            Privacy Policy
          </Link>
          <Link to="/legal/terms" className="text-secondary hover:text-primary">
            Terms
          </Link>
          <Link to="/legal/refund" className="text-secondary hover:text-primary">
            Refund Policy
          </Link>
          <Link to="/legal/disclaimer" className="text-secondary hover:text-primary">
            Disclaimer
          </Link>
          <Link
            to="/country-specific-invoice-generator/"
            className="text-secondary hover:text-primary"
          >
            Special invoice formats
          </Link>
          <Link
            to="/germany-france-invoice-generator/"
            className="text-secondary hover:text-primary"
          >
            Germany and France invoices
          </Link>
          <Link to="/no-upload-invoice-generator/" className="text-secondary hover:text-primary">
            No upload invoice generator
          </Link>
          <Link to="/free-invoice-generator/" className="text-secondary hover:text-primary">
            Free invoice generator
          </Link>
          {!invoiceOnly && (
            <Link to="/bulk-invoice-generator/" className="text-secondary hover:text-primary">
              Bulk invoice generator
            </Link>
          )}
          <Link to="/german-invoice-template/" className="text-secondary hover:text-primary">
            German invoice template
          </Link>
          <Link to="/france-invoice-template/" className="text-secondary hover:text-primary">
            France invoice template
          </Link>
          <a href="/ai-facts" className="text-secondary hover:text-primary">
            AI facts
          </a>
          <a href="/invoice-use-cases" className="text-secondary hover:text-primary">
            Use cases
          </a>
          <a href="mailto:info@polenest.com" className="text-secondary hover:text-primary">
            info@polenest.com
          </a>
        </div>
      </div>
    </footer>
  );
}
